import React from 'react';

interface DisclaimerFooterProps {
    footer: string[]; // array of strings
}

/**
 * Takes footer as a prop
 * Checks if footer is empty or undefined
 * Combines all the HTML string and injects them into a single container using dangerouslySetInnerHTML
 * Returns the expected HTML structure for the footer
 */
const DisclaimerFooter: React.FC<DisclaimerFooterProps> = ({ footer }) => {
    if (!footer?.length) return null;

    return (
        <div className="article-text text">
            <div
                id="disclaimer"
                className="cmp-text"
                dangerouslySetInnerHTML={{ __html: footer.join('') }}
            />
        </div>
    );
};

export default DisclaimerFooter;
